import { render } from "./Login.vue?vue&type=template&id=555a18b2"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Storage/Development/VintageTradingPost/chicken-auction-system/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__